module.exports = __webpack_public_path__ + "img/139.b9c5deee.jpg";